<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      {{heading}}
      <span class="badge">{{subscriptions.length}}</span>
    </div>

    <div class="panel-body">
      <template v-if="isDraggable" @start="drag=true" @end="drag=false">
        <draggable
          class="draggable-list"
          v-model="subscriptions"
          :options="{
            group: {
              name: 'subscriptions',
              put: canPut
            },
            filter: '.not-sortable',
            forceFallback: true,
            forceAutoscrollFallback: true,
            scroll: true,
            scrollSensitivity: 200,
            scrollSpeed: 50,
            bubbleScroll: true
          }"
        >
          <transition-group style="min-height: 10px; display: block;">
            <activity-subscription
              v-for="subscription in subscriptions"
              :list-type="list"
              :isDraggable="isDraggable"
              :key="subscription.id"
              :value="subscription.id"
              :subscription="subscription"
              :activity="activity"
            />
          </transition-group>
        </draggable>
      </template>
      <template v-else>
        <activity-subscription
          v-for="subscription in subscriptions"
          :list-type="list"
          :isDraggable="isDraggable"
          :key="subscription.id"
          :value="subscription.id"
          :subscription="subscription"
          :activity="activity"
        />
      </template>
      <!-- <activity-timeslot-subscription-entry v-if="isTimeslots" v-for="subscription in subscriptions" :value="subscription.id" :key="subscription.id"/> -->
      <!-- <activity-subscription-entry v-else v-for="subscription in subscriptions" :value="subscription.id" :key="subscription.id"/> -->
    </div>

    <div class="panel-footer">
      {{ heading }}
      <span class="badge">{{ subscriptions.length }}</span>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
  props: ["activity", "heading", "isDraggable", "list"],

  components: {
    draggable
  },

  computed: {
    subscriptions: {
      get() {
        return this.$store.state[`${this.list}Subscriptions`];
      },
      set(subscriptions) {
        this.$store.commit("updateSubscriptions", {
          list: this.list,
          subscriptions
        });

        this.$store.dispatch("saveSubscriptions");
      }
    }
  },

  methods: {
    canPut(to) {
      if (this.list !== "selected") {
        return true;
      }

      // Limit the amount of subscriptions in the selected list
      return to.el.children.length < this.$store.state.maxSubscriptions;
    }
  }
};
</script>

<style lang="scss" scoped>
.panel-body {
  height: calc(100% - 83px);

  .draggable-list {
    height: 100%!important;

    & > span {
      height: 100%!important;
    }
  }
}
</style>
